// 新协议
function kkmhhybrid_receive_page_status(opt) {
  hybrid({
    hybridParam: {
      schema: "kkmhhybrid",
      tagname: "receive_page_status",
    },
    param: {
      immediate: !!opt.immediate
    },
    on: true,
    callback: function (res,callbackName) {
      opt.callback && opt.callback(res,callbackName);
    }
  });
}

function kkhybrid_registViewStatus(opt){
  hybrid({
    hybridParam: {
      schema: "kkhybrid",
      tagname: "registViewStatus",
    },
    param: {},
    on: true,
    callback: function (res,callbackName) {
      if(res.data.isVisible == 0){
        opt.callback && opt.callback({
          curr_page_is_visible: res.data.isVisible
        },callbackName)
      }
    }
  });
}

function window_subscribeListenerOnViewBack(opt){
  window.subscribeListenerOnViewBack = function (res) {
    var fomatRes = res;
    if(typeof res === 'string'){
      fomatRes = JSON.parse(res);
    }
    var callBackParam = {
      curr_page_is_visible: 1,
      action_origin: fomatRes.app_origin,
      route_source_name: fomatRes.native_origin
    }
    opt.callback && opt.callback(callBackParam)
  };
}

/**
 * 接受页面状态<br>
 * window.subscribeListenerOnViewBack, wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=43387179}<br>
 * kkhybrid://kkhybrid_registViewStatus, wiki地址: {@link https://wiki.quickcan.com/pages/viewpage.action?pageId=38831865}<br>
 * kkmhhybrid://receive_page_status, wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=188974739}<br>
 * @param {Object} opt 参数对象
 * @param {Boolean} opt.immediate 注册协议后是否立即接收到回调(仅某个新版本待定-后支持)
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function receive_page_status(opt,criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion,554000);
  if (allow) {
    // 调用新协议
    kkmhhybrid_receive_page_status(opt);
    return;
  }
  kkhybrid_registViewStatus(opt);
  window_subscribeListenerOnViewBack(opt);
}

export default receive_page_status;



// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/receive_page_status/index.js